import {getProp, CanBeSignals} from '@gongxigames/framework/core/fragments/BuilderY';
import {Store, ComputedSignal} from '@gongxigames/framework/core/fragments/store/Store';
import {uiElementsStore} from '@gongxigames/framework/slotV2/ui/services/UIElementsStates/uiElementsStore';

export type BetSelectActions = 'increase' | 'decrease';
export type BetSelectOnChange = (action: BetSelectActions) => void;

export type BaseBetSelectPortraitProps = CanBeSignals<{
    betCurrent: number;
    betList: number[];
    isBuyFeature?: boolean;
}>;

export function computedDisablePlus(props: BaseBetSelectPortraitProps): ComputedSignal<boolean> {
    return Store.computed(() => {
        const bets = getProp(props.betList);
        const bet = getProp(props.betCurrent);
        const isBuyFeature = getProp(props.isBuyFeature);

        return (!bets.find(n => n > bet) || (uiElementsStore.bet_panel_disabled.value && !isBuyFeature));
    });
}

export function computedDisableMinus(props: BaseBetSelectPortraitProps): ComputedSignal<boolean> {
    return Store.computed(() => {
        const bets = getProp(props.betList);
        const bet = getProp(props.betCurrent);
        const isBuyFeature = getProp(props.isBuyFeature);

        return (!bets.find(n => n < bet) || (uiElementsStore.bet_panel_disabled.value && !isBuyFeature));
    });
}
